module.exports = __webpack_public_path__ + "img/eksun-logo.68614dcb.png";